"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processGetAddrResponse = void 0;
const ledger_js_1 = require("@zondax/ledger-js");
const consts_1 = require("./consts");
function processGetAddrResponse(response) {
    const errorCodeData = response.subarray(-2);
    const returnCode = errorCodeData[0] * 256 + errorCodeData[1];
    const publicKey = Buffer.from(response.subarray(0, consts_1.PKLEN));
    response = response.subarray(consts_1.PKLEN);
    const principal = Buffer.from(response.subarray(0, consts_1.PRINCIPAL_LEN));
    response = response.subarray(consts_1.PRINCIPAL_LEN);
    const address = Buffer.from(response.subarray(0, consts_1.ADDRLEN));
    response = response.subarray(consts_1.ADDRLEN);
    const principalText = Buffer.from(response.subarray(0, -2))
        .toString()
        .replace(/(.{5})/g, "$1-");
    return {
        publicKey,
        principal,
        address,
        principalText,
        returnCode,
        errorMessage: (0, ledger_js_1.errorCodeToString)(returnCode),
    };
}
exports.processGetAddrResponse = processGetAddrResponse;
